import { render, staticRenderFns } from "./StudentHome.vue?vue&type=template&id=511de6bc&scoped=true"
import script from "./StudentHome.vue?vue&type=script&lang=js"
export * from "./StudentHome.vue?vue&type=script&lang=js"
import style0 from "./StudentHome.vue?vue&type=style&index=0&id=511de6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511de6bc",
  null
  
)

export default component.exports